import React from 'react';
import { ProtectedPermissionRoute, ProtectedAdminRoute } from '@nimbitlabs/auth';
import { ReferralsPage } from './ReferralsPage';
import { SubscriptionPage } from '../subscriptions/SubscriptionPage';
import { BillingReturnPage } from './BillingReturnPage';

export const accountRoutes = [
  {
    path: '/referrals',
    element: <ProtectedAdminRoute><ProtectedPermissionRoute element={<ReferralsPage />} permission="settings:read" /></ProtectedAdminRoute>,
    permission: 'settings:read',
  },
  {
    path: '/subscription',
    element: <ProtectedAdminRoute><ProtectedPermissionRoute element={<SubscriptionPage />} permission="settings:read" /></ProtectedAdminRoute>,
    permission: 'settings:read',
  },
  {
    path: '/billing/return',
    element: <ProtectedPermissionRoute element={<BillingReturnPage />} permission="settings:read" />,
    permission: 'settings:read',
  },
];
